import type { CSSProperties } from 'react';
import type { ClickableScreenScene, ClickableScreenZone, ChoiceOption } from '../types';

export interface PercentCenterRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** Shared hotspot layout: center point in % of the scene container. */
export function percentCenterRectStyle(rect: PercentCenterRect): CSSProperties {
  return {
    left: `${rect.x}%`,
    top: `${rect.y}%`,
    width: `${rect.width}%`,
    height: `${rect.height}%`,
    transform: 'translate(-50%, -50%)',
  };
}

export function clickableZoneToChoiceOption(zone: ClickableScreenZone): ChoiceOption {
  return {
    text: zone.label,
    goto: zone.goto,
    actions: zone.actions,
    pedaShields: zone.pedaShields,
    pedaCategory: zone.pedaCategory,
    confidenceGains: zone.confidenceGains,
    condition: zone.condition,
  };
}

export function getVisibleClickableZones(
  scene: ClickableScreenScene,
  evaluateCondition: (condition: string) => boolean,
): ClickableScreenZone[] {
  return (scene.zones ?? []).filter(
    (zone) => !zone.condition || evaluateCondition(zone.condition),
  );
}

export function getClickableScreenMaxPedaShields(scene: ClickableScreenScene): number {
  let max = 0;
  for (const zone of scene.zones ?? []) {
    max = Math.max(max, zone.pedaShields ?? 0);
  }
  return max;
}

export function getClickableScreenRewardCategory(
  scene: ClickableScreenScene,
): ClickableScreenZone['pedaCategory'] | undefined {
  let best: ClickableScreenZone | undefined;
  let max = 0;
  for (const zone of scene.zones ?? []) {
    const shields = zone.pedaShields ?? 0;
    if (shields > max) {
      max = shields;
      best = zone;
    }
  }
  return best?.pedaCategory;
}
